<form autocomplete="off" novalidate [formGroup]="DefGrdForm">
    <div>
        <h4 class="main-content-label mb-1"><b>
            Add New Default Subject Grading Record
            </b></h4>
        <!-- <p class="text-muted card-sub-title mb-0">
            Add New Semester Information
           
        </p> -->
    </div>
   
    <div class="row clearfix">
        <div class="table-responsive table-container ">
            <table id="datatable" class="table widthTb table-bordered text-center">
                <thead>
                    <tr class="bgcolor">
                        <th width="20%" class="f600">Grade
                        </th>
                        <th width="20%" class="f600">Pass
                        </th>
                        <th width="20%" class="f600">Exam
                        </th>
                        <th width="20%" class="f600">Marks
                        </th>
                        <th width="20%" class="f600">Grade Points
                        </th>
                        <th width="20%" class="f600">Action
                        </th>
                    </tr>
                </thead>
                <tbody id="table_data" formArrayName="DefineGrid">
                    <tr *ngFor="let define of getDefineGridControls();let last =last; let i = index"
                    [formGroupName]="i">
                        <!-- [readonly]="disableDelete" -->
                        <td>
                            <input formControlName="GrGrade" maxlength="2" class="form-control input-sm" (keyup)="grade($event,i)">
                            <mat-error class="margin_tp" *ngIf="define.controls.GrGrade.touched && define.controls.GrGrade.errors?.required">
                                Mandatory
                            </mat-error>
                        </td>
                        <td>
                            <mat-select formControlName="GrPass">
                                <mat-option value="P" (click)="PassValue('P',i); enterPass(i, 'P')">
                                    Pass
                                </mat-option>
                                <mat-option value="F" (click)="PassValue('F',i)">
                                    Fail
                                </mat-option>
                                
                            </mat-select>
                            <mat-error class="margin_tp" *ngIf="define.controls.GrPass.touched && define.controls.GrPass.errors?.required">
                                Mandatory
                            </mat-error>
                            <mat-error class="margin_tp" *ngIf="define.get('GrPass').hasError('invalid')">
                                Invalid 
                            </mat-error>
                        </td>
                        <td>
                            <mat-select formControlName="GrExm">
                                <mat-option value="Y" (click)="ExamValue('Y',i)">
                                    Yes
                                </mat-option>
                                <mat-option value="N" (click)="ExamValue('N',i)">
                                    No
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp" *ngIf="define.controls.GrExm.touched && define.controls.GrExm.errors?.required">
                                Mandatory
                            </mat-error>
                        </td>
                        
                        <td>
                            <input matInput formControlName="GrMarks" maxlength="5" class="form-control input-sm" (keyup)="enterMarks(i, $event.target.value)">
                            <mat-error class="margin_tp"  *ngIf="define.controls['GrMarks'].touched && define.controls['GrMarks'].errors?.pattern">
                                Invalid 
                            </mat-error>
                            <mat-error class="margin_tp" *ngIf="define.controls.GrMarks.touched && define.controls.GrMarks.errors?.required">
                                Mandatory
                            </mat-error>
                        </td>
                        <td>
                            <input formControlName="Grpoints" maxlength="5" class="form-control input-sm">
                            <mat-error class="margin_tp" *ngIf="define.controls.Grpoints.touched && define.controls.Grpoints.errors?.required">
                                Mandatory
                            </mat-error>
                        </td>
                        <td>
                            <a *ngIf="last" class="btn-floating" title="AddNew">
                                <i (click)="addDefineGrdBtn(i+1)" class="fa fa-plus" aria-hidden="true"></i>
                                    
                            </a>
                            <a *ngIf="last" class="btn-floating" title="Remove">
                                <i (click)="deleteRow(i)" class="fa fa-minus" title="Delete"></i></a>
                                
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row prpl">
            <div class="col-sm-12">
                <button type="button"
                class="btn size fr btn-primary btn-icon-text floatleft mt-1"
                (click)="submit()">
                <span style="display: contents; align-items: center;">
                    <img width="20vh" src="../../assets/img/save.gif"
                        style="margin-right: 5px;">
                    Save
                </span>
            </button>
            
                <button type="button"
                class="btn fr size mar btn-primary btn-icon-text floatright mr-3 mt-1"
                (click)="back()">
                <span style="display: contents; align-items: center;">
                    <img width="20vh" src="../../assets/img/turn-left.gif"
                        style="margin-right: 7px;">
                    Back
                </span>
            </button>

            </div>
           
            <!-- <button  *ngIf="submitButton" type="button" class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                 (click)="submit()">
                 Submit
            </button> -->
           
            <!-- <button type="button" *ngIf="editButton"
            class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
            (click)="update()">
                Update
            </button> -->
             <!-- <button type="button"
                class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                (click)="back()">
                Back
            </button> -->
           
        </div>
    </div>
    
</form>